(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bps-purchase-reassurance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bps-delivery-info')) {
    customElements.define('bps-delivery-info', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        this.querySelector('[data-bps-open]').addEventListener('click', () => dialog.showModal());
        this.querySelector('[data-bps-close]').addEventListener('click', () => dialog.close());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
